import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  addSecurityOfficerFailure,
  addSecurityOfficerSuccess,
  deleteSecurityOfficerFailure,
  deleteSecurityOfficerSuccess,
  fetchSecurityOfficerFailure,
  fetchSecurityOfficersFailure,
  fetchSecurityOfficersSuccess,
  fetchSecurityOfficerSuccess,
  updateSecurityOfficerFailure,
  updateSecurityOfficerSuccess,
} from "./securityAction";
import {
  addSecurityOfficerEffect,
  deleteSecurityOfficerEffect,
  editSecurityOfficerEffect,
  listSecurityOfficerEffect,
  viewSecurityOfficerEffect,
} from "./securityEffect";
import {
  ADD_SECURITY_OFFICER_REQUEST,
  DELETE_SECURITY_OFFICER_REQUEST,
  FETCH_LIST_SECURITY_OFFICERS_REQUEST,
  FETCH_SECURITY_OFFICER_REQUEST,
  UPDATE_SECURITY_OFFICER_REQUEST,
} from "./securityType";

function* fetchSecurityOfficersSaga(action) {
 
  try {
    const securityOfficers = yield call(listSecurityOfficerEffect, action.payload);
    yield put(fetchSecurityOfficersSuccess(securityOfficers));
  } catch (error) {
    yield put(fetchSecurityOfficersFailure(error.message));
  }
}

function* fetchSecurityOfficerSaga(action) {
  try {
    const securityOfficer = yield call(viewSecurityOfficerEffect, action.payload.securityOfficerId);
    
    yield put(fetchSecurityOfficerSuccess(securityOfficer?.data));
  } catch (error) {
    yield put(fetchSecurityOfficerFailure(error.message));
  }
}

function* addSecurityOfficerSaga(action) {
  try {
    const newSecurityOfficer = yield call(addSecurityOfficerEffect, action.payload.securityOfficerData);
    const securityData = newSecurityOfficer.data || newSecurityOfficer;
    yield put(addSecurityOfficerSuccess(securityData));
  } catch (error) {
    const backendMessage = error.response?.data?.message || error.message || "Add Security Officer failed";
    yield put(addSecurityOfficerFailure(backendMessage));
  }
}

function* updateSecurityOfficerSaga(action) {
  try {
    const updatedSecurityOfficer = yield call(
      editSecurityOfficerEffect,
      action.payload.securityOfficerId,
      action.payload.securityOfficerData
    );
    yield put(updateSecurityOfficerSuccess(updatedSecurityOfficer));
  } catch (error) {
    const backendMessage = error.response?.data?.message || error.message || "Update Security Officer failed";
    yield put(updateSecurityOfficerFailure(backendMessage));
  }
}

function* deleteSecurityOfficerSaga(action) {
  try {
    yield call(deleteSecurityOfficerEffect, action.payload.securityOfficerId);
    yield put(deleteSecurityOfficerSuccess(action.payload.securityOfficerId));
  } catch (error) {
    yield put(deleteSecurityOfficerFailure(error.message));
  }
}

function* watchFetchSecurityOfficers() {
  yield takeLatest(FETCH_LIST_SECURITY_OFFICERS_REQUEST, fetchSecurityOfficersSaga);
}

function* watchFetchSecurityOfficer() {
  yield takeLatest(FETCH_SECURITY_OFFICER_REQUEST, fetchSecurityOfficerSaga);
}

function* watchAddSecurityOfficer() {
  yield takeLatest(ADD_SECURITY_OFFICER_REQUEST, addSecurityOfficerSaga);
}

function* watchUpdateSecurityOfficer() {
  yield takeLatest(UPDATE_SECURITY_OFFICER_REQUEST, updateSecurityOfficerSaga);
}

function* watchDeleteSecurityOfficer() {
  yield takeLatest(DELETE_SECURITY_OFFICER_REQUEST, deleteSecurityOfficerSaga);
}

export function* securityOfficerSagas() {
  yield all([
    watchFetchSecurityOfficers(),
    watchFetchSecurityOfficer(),
    watchAddSecurityOfficer(),
    watchUpdateSecurityOfficer(),
    watchDeleteSecurityOfficer(),
  ]);
}